import { createAction, props } from '@ngrx/store';

export enum StoreCouponsActionTypes {
  loadCouponsBegin = '[STORE] Load Coupons Begin',
  loadCouponsSuccess = '[STORE] Load Coupons Success',
  loadCouponsFail = '[STORE] Load Coupons Fail',

  loadCouponsByIdBegin = '[STORE] Load Coupons By Id Begin',
  loadCouponsByIdSuccess = '[STORE] Load Coupons By Id Success',
  loadCouponsByIdFail = '[STORE] Load Coupons By Id Fail',

  createCouponBegin = '[STORE] Create Coupons Begin',
  createCouponSuccess = '[STORE] Create Coupons Success',
  createCouponFail = '[STORE] Create Coupons Fail',

  updateCouponBegin = '[STORE] Update Coupons Begin',
  updateCouponSuccess = '[STORE] Update Coupons Success',
  updateCouponFail = '[STORE] Update Coupons Fail',

  deleteCouponBegin = '[STORE] Delete Coupons Begin',
  deleteCouponSuccess = '[STORE] Delete Coupons Success',
  deleteCouponFail = '[STORE] Delete Coupons Fail',

  loadSingleCouponBegin = '[STORE] Load Single Coupons Begin',
  loadSingleCouponSuccess = '[STORE] Load Single Coupons Success',
  loadSingleCouponFail = '[STORE] Load Single Coupons Fail',

  loadUpdatedCouponBegin = '[STORE] Load Updated Coupons Begin',
  loadUpdatedCouponSuccess = '[STORE] Load Updated Coupons Success',
  loadUpdatedCouponFail = '[STORE] Load Updated Coupons Fail',

  clearCouponsSuccessErrorData = '[STORE] Clear Coupons Success/Error Data',
}

export const loadCouponsBeginAction = createAction(
  StoreCouponsActionTypes.loadCouponsBegin
);

export const loadCouponsuccessAction = createAction(
  StoreCouponsActionTypes.loadCouponsSuccess,
  props<{ payload: any[] }>()
);

export const loadCouponsFailAction = createAction(
  StoreCouponsActionTypes.loadCouponsFail,
  props<{ errors: any }>()
);

export const loadCouponByIdBeginAction = createAction(
  StoreCouponsActionTypes.loadCouponsByIdBegin,
  props<{ id: number }>()
);

export const loadCouponByIdSuccessAction = createAction(
  StoreCouponsActionTypes.loadCouponsByIdSuccess,
  props<{ payload: any }>()
);

export const loadCouponByIdFailAction = createAction(
  StoreCouponsActionTypes.loadCouponsByIdFail,
  props<{ errors: any }>()
);

export const createCouponBeginAction = createAction(
  StoreCouponsActionTypes.createCouponBegin,
  props<{ payload: any }>()
);

export const createCouponSuccessAction = createAction(
  StoreCouponsActionTypes.createCouponSuccess,
  props<{ payload: any }>()
);

export const createCouponFailAction = createAction(
  StoreCouponsActionTypes.createCouponFail,
  props<{ errors: any }>()
);

export const updateCouponBeginAction = createAction(
  StoreCouponsActionTypes.updateCouponBegin,
  props<{ payload: any }>()
);

export const updateCouponSuccessAction = createAction(
  StoreCouponsActionTypes.updateCouponSuccess,
  props<{ payload: any }>()
);

export const updateCouponFailAction = createAction(
  StoreCouponsActionTypes.updateCouponFail,
  props<{ errors: any }>()
);

export const deleteCouponBeginAction = createAction(
  StoreCouponsActionTypes.deleteCouponBegin,
  props<{ id: number }>()
);

export const deleteCouponSuccessAction = createAction(
  StoreCouponsActionTypes.deleteCouponSuccess,
  props<{ payload: any[] }>()
);

export const deleteCouponFailAction = createAction(
  StoreCouponsActionTypes.deleteCouponFail,
  props<{ errors: any }>()
);

export const clearCouponsuccessErrorDataAction = createAction(
  StoreCouponsActionTypes.clearCouponsSuccessErrorData
);

export const loadSingleCouponBeginAction = createAction(
  StoreCouponsActionTypes.loadSingleCouponBegin,
  props<{ id: number }>()
);

export const loadSingleCouponSuccessAction = createAction(
  StoreCouponsActionTypes.loadSingleCouponSuccess,
  props<{ payload: any[] }>()
);

export const loadSingleCouponFailAction = createAction(
  StoreCouponsActionTypes.loadSingleCouponFail,
  props<{ errors: any }>()
);

export const loadUpdatedCouponBeginAction = createAction(
  StoreCouponsActionTypes.loadUpdatedCouponBegin,
  props<{ id: number }>()
);

export const loadUpdatedCouponSuccessAction = createAction(
  StoreCouponsActionTypes.loadUpdatedCouponSuccess,
  props<{ payload: any }>()
);

export const loadUpdatedCouponFailAction = createAction(
  StoreCouponsActionTypes.loadUpdatedCouponFail,
  props<{ errors: any }>()
);


